/**
 * Dealflow Deck API
 * API to by used by deck
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { DeckPitchesSubscription } from './deck-pitches-subscription';

export interface PaginatedDeckPitchesSubscriptionList {
  count?: number;
  next?: string | null;
  previous?: string | null;
  results?: Array<DeckPitchesSubscription>;
}
